module.exports = __webpack_public_path__ + "img/title.60e981ca.png";